import React, { useState } from 'react';
import { Button } from '@vacasa/react-components-lib';
import { Alert } from '@mui/material';
import { useSyncUnitFromPalMutation } from '../../services/ReviewsService';
import './UnitSync.scss';

export const UnitSync: React.FC = () => {
    const [adminUnitId, setAdminUnitId] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [syncUnitFromPal, { isLoading }] = useSyncUnitFromPalMutation();

    const handleAdminUnitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAdminUnitId(event.target.value.replace(/\D/g, ''));
    };

    const onSync = async () => {
        const unitId = Number(adminUnitId.trim());
        if (!Number.isFinite(unitId) || unitId <= 0) {
            setIsError(true);
            setMessage('Enter a valid admin unit id.');
            return;
        }

        try {
            setIsError(false);
            setMessage('');
            const result = await syncUnitFromPal({ admin_unit_id: unitId }).unwrap();
            if (result.created) {
                setMessage(`Unit ${unitId} created from PAL.`);
            } else if (result.updated) {
                setMessage(`Unit ${unitId} updated from PAL.`);
            } else {
                setMessage(`Unit ${unitId} already up to date with PAL.`);
            }
        } catch (_e) {
            setIsError(true);
            setMessage('Unable to sync unit from PAL. Please try again.');
        }
    };

    return (
        <div className="unit-sync">
            <div className="unit-sync-header">
                <h3>Unit Sync</h3>
                <p>
                    Fetch a unit from PAL by admin unit id and create or update the local unit when name, location, image, active status, or
                    property manager config differs.
                </p>
            </div>

            {message && <Alert severity={isError ? 'error' : 'success'}>{message}</Alert>}

            <div className="filters">
                <div className="field">
                    <label>
                        Admin Unit ID
                        <input value={adminUnitId} onChange={handleAdminUnitChange} type="text" inputMode="numeric" />
                    </label>
                </div>
            </div>

            <div className="unit-sync-actions">
                <Button variant="secondary" onClick={onSync} disabled={isLoading || adminUnitId.trim() === ''}>
                    Sync unit from PAL
                </Button>
            </div>
        </div>
    );
};
